import VueMobileDetection from "vue-mobile-detection";
import Vue from 'vue'


Vue.use(VueMobileDetection);
